import {useRef} from "react";

import {createInvestmentApartmentsAmplitudeItemListId, getInvestmentApartmentsAmplitudeRequestKey} from "./create_investment_apartments_amplitude_item_list_id";

interface IUseInvestmentApartmentsAmplitudeItemListIdParams {
    offerId: number | null | undefined;
    page?: number | null;
    sort?: number | string | null;
    filters?: Record<string, unknown> | null;
    isResponseReady: boolean;
    backendQueryId?: string | null;
}

export const useInvestmentApartmentsAmplitudeItemListId = ({
    offerId,
    page,
    sort,
    filters,
    isResponseReady,
    backendQueryId
}: IUseInvestmentApartmentsAmplitudeItemListIdParams): string | undefined => {
    const currentRef = useRef<{requestKey: string; itemListId: string} | null>(null);

    if (offerId == null || !isResponseReady) {
        return currentRef.current?.itemListId;
    }

    const requestKey = getInvestmentApartmentsAmplitudeRequestKey({offerId, page, sort, filters});

    if (currentRef.current?.requestKey !== requestKey) {
        currentRef.current = {
            requestKey,
            itemListId: createInvestmentApartmentsAmplitudeItemListId({offerId, backendQueryId})
        };
    }

    return currentRef.current.itemListId;
};
import {useRef} from "react";

import {createInvestmentApartmentsAmplitudeItemListId, getInvestmentApartmentsAmplitudeRequestKey} from "./create_investment_apartments_amplitude_item_list_id";

interface IUseInvestmentApartmentsAmplitudeItemListIdParams {
    offerId: number | null | undefined;
    page?: number | null;
    sort?: number | string | null;
    filters?: Record<string, unknown> | null;
    isResponseReady: boolean;
    backendQueryId?: string | null;
}

export const useInvestmentApartmentsAmplitudeItemListId = ({
    offerId,
    page,
    sort,
    filters,
    isResponseReady,
    backendQueryId
}: IUseInvestmentApartmentsAmplitudeItemListIdParams): string | undefined => {
    const currentRef = useRef<{requestKey: string; itemListId: string} | null>(null);

    if (offerId == null || !isResponseReady) {
        return currentRef.current?.itemListId;
    }

    const requestKey = getInvestmentApartmentsAmplitudeRequestKey({offerId, page, sort, filters});

    if (currentRef.current?.requestKey !== requestKey) {
        currentRef.current = {
            requestKey,
            itemListId: createInvestmentApartmentsAmplitudeItemListId({offerId, backendQueryId})
        };
    }

    return currentRef.current.itemListId;
};
